/* ══ BDT · night vision toggle + loadout builder ══ */
(function(){
var $=function(s,r){return (r||document).querySelector(s)},$$=function(s,r){return [].slice.call((r||document).querySelectorAll(s))};
var R=matchMedia('(prefers-reduced-motion: reduce)').matches,root=document.documentElement;

/* ── scroll safety net: if a smooth scroll stalls (throttled frames, embeds), snap to target ── */
(function(){
  var native=window.scrollTo.bind(window),tk;
  window.scrollTo=function(a,b){
    if(a&&typeof a==='object'&&a.behavior==='smooth'&&typeof a.top==='number'){
      var from=window.pageYOffset,to=Math.max(0,a.top);
      native(a);clearTimeout(tk);
      tk=setTimeout(function(){
        var now=window.pageYOffset;
        if(Math.abs(to-from)>4&&Math.abs(now-from)<2)native(0,to);
      },650);
      return;
    }
    return native.apply(window,arguments);
  };
})();

/* ── night vision ── */
var scan=document.createElement('div');scan.className='nvscan';scan.innerHTML='<i></i>';document.body.appendChild(scan);
function label(){
  var night=root.dataset.theme==='night';
  $$('.nvb').forEach(function(b){
    b.setAttribute('aria-pressed',night?'true':'false');
    var s=$('.lbl',b);if(s)s.textContent=night?'Night vision on':'Night vision';
  });
}
function setTheme(t){root.dataset.theme=t;try{localStorage.setItem('bdt-theme',t)}catch(e){}label()}
function toggle(){
  var next=root.dataset.theme==='night'?'ice':'night';
  if(R){setTheme(next);return}
  scan.classList.remove('go');void scan.offsetWidth;scan.classList.add('go');
  setTimeout(function(){setTheme(next)},330);
  setTimeout(function(){scan.classList.remove('go')},800);
}
document.addEventListener('click',function(e){if(e.target.closest('.nvb')){e.preventDefault();toggle()}});
document.addEventListener('keydown',function(e){
  if(e.metaKey||e.ctrlKey||e.altKey)return;
  var tg=e.target;if(tg&&/input|textarea|select/i.test(tg.tagName))return;
  if((e.key||'').toLowerCase()==='n'){e.preventDefault();toggle()}
});
var lg=$('.keys');if(lg)lg.insertAdjacentHTML('beforeend','<span><b>N</b> night vision</span>');
label();

/* ── loadout ── */
var lo=$('#loadout');if(!lo)return;
var S={clear:2,cloth:2,wax:1,clothC:'w',waxS:'fp'},FREE=75,active='clear';
var PRICE={clear:3.85,cloth:{w:4.65,b:4.75},wax:7.10};
function sub(){return S.clear*PRICE.clear+S.cloth*PRICE.cloth[S.clothC]+S.wax*PRICE.wax}
function money(v){return '$'+v.toFixed(2)}
function render(){
  ['clear','cloth','wax'].forEach(function(k){var o=$('#q-'+k);if(o)o.textContent=S[k]});
  $$('[data-opt]',lo).forEach(function(b){b.setAttribute('aria-pressed',S[b.dataset.opt]===b.dataset.v?'true':'false')});
  var t=sub(),n=S.clear+S.cloth+S.wax;
  $('#lo-total').textContent=money(t);
  $('#lo-items').textContent=n+(n===1?' roll / tin':' rolls & tins');
  $('#lo-fill').style.width=Math.min(100,t/FREE*100)+'%';
  var m=$('.meter',lo),msg=$('#lo-msg');
  if(t>=FREE){m.classList.add('win');msg.textContent='Free shipping unlocked'}
  else{m.classList.remove('win');msg.textContent=money(FREE-t)+' to free shipping'}
  var add=$('#lo-add');add.disabled=n===0;add.style.opacity=n===0?.45:1;
}
function focus(k){
  active=k;
  $$('.slot',lo).forEach(function(s){s.classList.toggle('on',s.dataset.slot===k)});
  $$('.lo-svg .hs',lo).forEach(function(h){h.classList.toggle('on',h.dataset.slot===k)});
  $$('.lo-svg .pt',lo).forEach(function(p){p.classList.toggle('on',p.dataset.part===k)});
}
lo.addEventListener('click',function(e){
  var st=e.target.closest('[data-step]');
  if(st){var k=st.dataset.step;S[k]=Math.max(0,Math.min(48,S[k]+(+st.dataset.d)));focus(k);render();return}
  var op=e.target.closest('[data-opt]');
  if(op){S[op.dataset.opt]=op.dataset.v;focus(op.closest('.slot').dataset.slot);render();return}
  var hs=e.target.closest('.hs');
  if(hs){focus(hs.dataset.slot);var sl=$('.slot[data-slot="'+hs.dataset.slot+'"]',lo);if(sl&&innerWidth<1180)window.scrollTo({top:sl.getBoundingClientRect().top+pageYOffset-(window.BDTOFF?BDTOFF():120),behavior:R?'auto':'smooth'});return}
  var sl2=e.target.closest('.slot');
  if(sl2){focus(sl2.dataset.slot);return}
  if(e.target.closest('#lo-add')){
    var n=S.clear+S.cloth+S.wax;if(!n)return;
    document.dispatchEvent(new CustomEvent('bdt:add',{detail:n}));
    var b=$('#lo-add'),t=b.textContent;b.textContent='Loadout added ✓';setTimeout(function(){b.textContent=t},1400);
  }
});
lo.addEventListener('keydown',function(e){
  var hs=e.target.closest&&e.target.closest('.hs');
  if(hs&&(e.key==='Enter'||e.key===' ')){e.preventDefault();hs.dispatchEvent(new MouseEvent('click',{bubbles:true}))}
});
focus(active);render();
})();

/* ── news rail: arrows, drag, progress ── */
(function(){
var hm=document.getElementById('hdmain');if(!hm)return;
var th=[].slice.call(document.querySelectorAll('.pthumbs button')),i=0;
function go(k){i=(k+th.length)%th.length;var b=th[i];hm.style.opacity=0;setTimeout(function(){hm.src=b.dataset.hd;hm.alt=b.dataset.cap;hm.style.opacity=1},150);document.getElementById('hdcap').textContent=b.dataset.cap;th.forEach(function(x,j){x.classList.toggle('on',j===i)})}
th.forEach(function(b,k){b.addEventListener('click',function(){go(k)})});
document.addEventListener('click',function(e){if(e.target.closest('[data-hd-next]')){e.preventDefault();go(i+1)}});
})();
/* ── news rail: arrows, drag, progress ── */
(function(){
var r=document.getElementById('nxrail');if(!r)return;
var f=document.getElementById('nxfill');
function bar(){var m=r.scrollWidth-r.clientWidth,w=Math.max(12,r.clientWidth/r.scrollWidth*100);f.style.width=w+'%';f.style.left=(m>0?r.scrollLeft/m*(100-w):0)+'%'}
r.addEventListener('scroll',bar,{passive:true});addEventListener('resize',bar);bar();
document.addEventListener('click',function(e){var b=e.target.closest('[data-nx]');if(!b)return;var c=r.querySelector('.nx');r.scrollBy({left:(+b.dataset.nx)*((c?c.offsetWidth:360)+20),behavior:'smooth'})});
var down=false,sx=0,sl=0,moved=0;
r.addEventListener('pointerdown',function(e){if(e.pointerType!=='mouse')return;down=true;moved=0;sx=e.clientX;sl=r.scrollLeft;r.classList.add('drag')});
addEventListener('pointermove',function(e){if(!down)return;var d=e.clientX-sx;moved=Math.max(moved,Math.abs(d));r.scrollLeft=sl-d});
addEventListener('pointerup',function(){if(!down)return;down=false;r.classList.remove('drag')});
r.addEventListener('click',function(e){if(moved>6){e.preventDefault();e.stopPropagation();moved=0}},true);
})();

document.addEventListener('click',function(e){var b=e.target.closest('[data-srl]');if(!b)return;var r=document.getElementById(b.dataset.srlT||'srl');if(!r)return;var c=r.firstElementChild;var w=c?c.getBoundingClientRect().width+16:300;r.scrollBy({left:(+b.dataset.srl)*w*2,behavior:'smooth'})});

document.addEventListener('click',function(e){var a=e.target.closest('[data-clbgo]');if(!a)return;e.preventDefault();e.stopPropagation();var f=document.getElementById('collab-form');if(f)scrollTo({top:f.getBoundingClientRect().top+scrollY-120,behavior:'smooth'})},true);

document.addEventListener('submit',function(e){var f=e.target.closest&&e.target.closest('[data-shopify-login]');if(!f)return;e.preventDefault();e.stopImmediatePropagation();location.href=f.getAttribute('action')},true);
